export const formatDate = (date?: string) => {
  if (!date) return '';
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(new Date(date));
};
